import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

export const VerticalExpansion = trigger(
	'verticalExpansion', [
		transition(':enter', [
			style({ height: 0 }),
			animate('85ms ease-out', style({ height: AUTO_STYLE })),
		]),
		transition(':leave', [
			style({ overflow: "hidden" }),
			animate('100ms ease-in', style({ height: 0 })),
		]),
	]
)

export const VerticalExpansionSlower = trigger(
	'verticalExpansionSlower', [
		transition(':enter', [
			style({ height: 0 }),
			animate('210ms ease-out', style({ height: AUTO_STYLE })),
		]),
		transition(':leave', [
			style({ overflow: "hidden" }),
			animate('210ms ease-out', style({ height: 0 })),
		]),
	]
)

/**
 * Para que algo se anime después de otra VerticalExpansionSlower, pero que se activan al mismo tiempo porque dependen de un ngIf
 * No me salió de otra forma
 */
export const VerticalExpansionSlower_withDelay = trigger(
	'verticalExpansionSlower_withDelay', [
		transition(':enter', [
			style({ height: 0 }),
			animate('200ms 270ms ease-out', style({ height: AUTO_STYLE })),
		]),
		transition(':leave', [
			style({ overflow: "hidden" }),
			animate('200ms 270ms ease-out', style({ height: 0 })),
		]),
	]
)

export const VerticalExpansion_withOpacity = trigger(
	'verticalExpansion_withOpacity', [
		transition(':leave', [
			style({ overflow: "hidden" }),
			animate('200ms ease-out', style({ height: 0, opacity: 0 })),
		]),
	]
)

/*
export const twoPartAnimation = trigger("twoPartAnimation", [
	state("part1", style({
		left: "0%"
	})),
	state("part2", style({
		left: "calc(-100% - 36px)"
	})),
	transition("part1 => part2", animate("0.35s ease-in-out")),
	transition("part2 => part1", animate("0.44s ease-in")),
]);
*/